/**
 * Small "i" info hint — hover the icon to read a short explanation.
 * Reuses the shared Tooltip so the whole performance view is self-explanatory.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC, ReactNode } from 'react';
import { Info } from 'lucide-react';

import { Tooltip } from '@/components/ui';
import { cn } from '@/lib/utils';

interface InfoHintProps {
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom';
  className?: string;
  /** Accessible label for the icon (defaults to "More info"). */
  label?: string;
}

export const InfoHint: FC<InfoHintProps> = ({ children, side = 'top', className, label = 'More info' }) => (
  <Tooltip
    side={side}
    interactive
    content={<span className="block max-w-[18rem] text-xs leading-relaxed">{children}</span>}
  >
    <Info
      aria-label={label}
      className={cn(
        'h-3.5 w-3.5 shrink-0 cursor-help text-muted-foreground transition-colors hover:text-foreground',
        className,
      )}
    />
  </Tooltip>
);

export default InfoHint;
